<ng-template #notification let-message let-snackBarRef="snackBarRef">
  <div class="toast {{message.type}}" style="opacity: 1;" role="alert" (click)="snackBarRef.dismiss()">
    <div class="toast-header">
      <div class="d-flex w-100">
        <mat-icon aria-hidden="false">{{notificationIcons[message.type]?.icon}}</mat-icon>
        <h5 class="mb-0">{{message.title}}</h5>
        <i class="icon-Cancel ml-auto"></i>
      </div>
      <small class="ml-auto"></small>
      &nbsp;
    </div>
    @if (message.content) {
      <div class="toast-body text-dark">
        {{message.content}}
      </div>
    }
  </div>
</ng-template>
